import { searchStore } from 'owa-mail-search-store';
export default function isDateRefinerApplied() {
    return searchStore.fromDate !== null || searchStore.toDate !== null;
}
//# sourceMappingURL=isDateRefinerApplied.js.map